import VPN from './vpn';

export default {
    VPN
}